<template>
  <div :class="$style.container">
    <div :class="$style.banner">
      <div class="main-width">
        <!-- <el-breadcrumb :class="$style.breadcrumb" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>成为合作伙伴</el-breadcrumb-item>
          </el-breadcrumb> -->
        <div :class="$style.breadcrumb">
          <nuxt-link :class="$style.breadcrumb_item" to="/">首页</nuxt-link>
          <span :class="$style.breadcrumb_separator"><i class="el-icon-arrow-right" /></span>
          <span :class="$style.breadcrumb_item">成为合作伙伴</span>
        </div>
        <div :class="$style.title">
          致力于打造全方位、行业领先的<br>邮轮服务平台
        </div>
        <button :class="$style.settled_btn" v-if="userInfo?.type !== 3" type="wraning" @click="handlerSettled">免费入驻</button>
      </div>
    </div>
    <div class="overflow-hidden">
      <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
        <img class="object-cover mx-auto" src="~/assets/img/settled/img-1.png" alt="打通邮轮产业链" />
      </div>
    </div>
    <div class="overflow-hidden bg-[#005EDC]">
      <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
        <img class="object-cover mx-auto" src="~/assets/img/settled/img-2.png" alt="全球邮轮信息查询服务" />
      </div>
    </div>
    <div class="overflow-hidden">
      <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
        <img class="object-cover mx-auto" src="~/assets/img/settled/img-3.png" alt="我们的服务" />
      </div>
    </div>
    <div class="overflow-hidden bg-[#617183]">
      <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
        <img class="object-cover mx-auto" src="~/assets/img/settled/img-4.png" alt="平台" />
      </div>
    </div>
    <div class="overflow-hidden" :class="$style.bg_liner">
      <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
        <img class="object-cover mx-auto" src="~/assets/img/settled/img-5.png" alt="我们的服务" />
      </div>
    </div>
    <CompanyScroll />

    <div class="overflow-hidden bg-[#01285C]">
      <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto relative">
        <img class="object-cover mx-auto" src="~/assets/img/settled/img-6.png" alt="全球邮轮信息查询服务" />
        <div class="absolute inset-0 flex items-center justify-center">
          <button
            class="bg-warn text-white font-medium text-2xl h-14 w-46 rounded transition transition-colors hover:bg-opacity-90"
            @click="handlerSettled">免费入驻</button>
          <button
            class="bg-primary text-white font-medium text-2xl h-14 w-46 ml-13 rounded transition transition-colors hover:bg-opacity-90"
            @click="openContact">立即咨询</button>
        </div>
      </div>
    </div>
    <!-- <SettledBanner></SettledBanner> -->
    <!-- <SettledProcess></SettledProcess> -->
    <!-- <Register></Register> -->
</div>
</template>
<script>
import SettledBanner from "views/settled/SettledBanner.vue";
import SettledProcess from "views/settled/SettledProcess.vue";
import Register from "@/components/Register";
import CompanyScroll from '~/views/home/CompanyScroll.vue'

import { defineComponent, useStore, useRouter, computed } from "@nuxtjs/composition-api";
import useLoginDialog from "~/composables/useLoginDialog";
import { useContactStore } from "~/composables/useContactDialog";
export default defineComponent({
  name: "Settled",
  auth: false,
  layout: 'Main',
  head: {
    title: '成为合作伙伴'
  },
  components: {
    SettledBanner,
    SettledProcess,
    Register,

    CompanyScroll
  },
  setup() {
    const { showSettled } = useLoginDialog()
    const { open: openContact } = useContactStore();

    const store = useStore();
    // const isDistributor = computed(() => store.getters.isDistributor);
    const loggedIn = computed(() => store.getters.loggedIn);
    const userInfo = computed(() => store.getters.userInfo)
    const router = useRouter();
    const handlerSettled = () => {
      if (!loggedIn.value) {
        showSettled();
      } else {
        router.push('/settled/process')
      }
    }
    return {
      userInfo,
      openContact,
      handlerSettled,
      // showContactDialog
    }
  },
});
</script>

<style lang="scss" module>
.container {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.banner {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 33.75rem;
  padding-top: 0.75rem;
  background-image: url("~/assets/img/home/home_banner1.png");
}
.title {
  font-weight: 700;
  font-size: 56px;
  line-height: 1;
  line-height: 66px;
  margin-top: 6.75rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  text-shadow: 0px 0px 15px rgba(0, 0, 0, 0.4);
}
.settled_btn {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 169, 0, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  font-weight: 500;
  height: 3.5rem;
  font-size: 24px;
  line-height: 1;
  line-height: 3.5rem;
  margin-top: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  width: 11.5rem;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
}
.settled_btn:hover {
  --tw-bg-opacity: 0.8;
}
.breadcrumb {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.bg_liner {
  background: url('~/assets/img/settled/bg-liner.png') repeat-x bottom;
}
</style>
